<template>
  <div class="hero">
    <scroll-speed :speed=".7" :clamp="true">
      <div slot-scope="{}" class="hero__text" :style="{'opacity': opacity}">
        <split-text :dur="0.9">
          <h2 slot-scope="{}">
            Client:
            <b>{{ client }}</b>
          </h2>
        </split-text>

        <split-text :dur="1.2" :stagger="0.1">
          <h1 slot-scope="{}">{{ msg }}</h1>
        </split-text>
      </div>
    </scroll-speed>

    <scroll-speed :speed=".2" :clamp="true">
      <div slot-scope="{}" class="hero__scroll-text">
        <split-text :dur="2.0">
          <p slot-scope="{}">Scroll down</p>
        </split-text>
      </div>
    </scroll-speed>

    <scroll-speed :speed=".4" :clamp="true">
      <responsive-image
        :image="imageLandscape"
        :image2="imagePortrait"
        slot-scope="{}"
        class="hero__image"
        :style="{'opacity': opacity}"
      />
    </scroll-speed>
  </div>
</template>

<script>
import { mapState } from "vuex";
import imagesLoaded from "imagesloaded";
import splitText from "@/components/split-text";
import scrollSpeed from "@/components/scroll-speed";
import responsiveImage from "@/components/responsive-image";

export default {
  name: "Hero",
  components: { splitText, scrollSpeed, responsiveImage },
  props: {
    msg: String,
    client: String,
    imageLandscape: String,
    imagePortrait: String
  },
  computed: mapState({
    currentScroll: state => state.globals.currentScroll,
    cloneElement: state => state.cloneElement,
    opacity() {
      return Math.max(1 - this.currentScroll / (window.innerHeight * 1.2), 0);
    }
  }),
  mounted() {
    if (this.$store.state.cloneElement) {
      imagesLoaded(this.$el, { background: true }, () => {
        // with a minimal delay to prevent glitch
        setTimeout(() => {
          this.$store.commit("removeCloneElement");
        }, 50);
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../scss/globals.scss";

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

.hero {
  display: flex;
  align-items: flex-end;

  position: relative;
  top: 0;
  width: 100%;
  height: 70vh;

  overflow: hidden;

  background-color: $color-white;
  box-sizing: border-box;

  @media screen and (min-width: 440px) {
    height: 120vh;
  }

  &__text {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    bottom: 0;
    left: 0;
    z-index: 2;
    position: absolute;

    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.01);

    max-width: 100%;
    box-sizing: border-box;

    padding: $margin1-2 $margin1-8;

    @media screen and (min-width: 440px) {
      bottom: 30vh;
      padding: 0 $margin1-4;
      top: 70vh;
    }

    @media screen and (min-width: 769px) {
      padding: 0 $margin1-2;
    }

    @media screen and (min-width: 1025px) {
      padding: 0 $margin1-1;
    }

    h2 {
      @include typeset(display-3);
      letter-spacing: 0.05em;
    }

    h1 {
      @include typeface(expanded);
      @include typeset(hero);

      margin-top: 0.2em;
      max-width: 18em;
    }
  }

  &__scroll-text {
    display: none;
    animation: pulse 2s 1.2s infinite linear;
    align-items: center;
    justify-content: center;

    position: absolute;
    height: $menu-height;
    bottom: 20vh;
    z-index: 2;
    width: 100%;

    text-align: center;
    text-transform: uppercase;

    @media screen and (min-width: 440px) {
      display: flex;
    }

    p {
      @include typeset(trumpet);
      font-weight: bold;
    }
  }

  &__image {
    display: flex;
    align-items: center;
    transition: opacity 1s $very-ease-out; //, transform $transition-scroll;
    position: absolute;
    top: 0;
    left: 0;

    z-index: 1;

    width: 100vw;
    height: 100%;
    overflow: hidden;
    background: center / cover no-repeat;

    box-sizing: border-box;

    img {
      width: auto;
      height: 100%;
      min-width: 100vw;
    }
  }
}
</style>
